module.exports = __webpack_public_path__ + "assets/img/role_menpai_name-b79bfd69.png";